export default __webpack_public_path__ + "static/media/meliImg_2.9a9bb09e.webp";